<template>
  <div
    v-if="processedLink"
    class="qonfi-helper"
  >
    <h3 class="qonfi-helper__title heading heading--4">
      {{ computedTitle }}
    </h3>
    <div class="qonfi-helper__content">
      <span class="qonfi-helper__subtitle">
        {{ computedSubTitle }}
      </span>
      <appLink
        :to="processedLink"
        class="qonfi-helper__button button button--cta button--full button"
      >
        <span>{{ computedButtonText }}</span>
        <IconCssArrow2 class="icon icon--arrow icon--arrow-right" />
      </appLink>
    </div>
  </div>
</template>

<script setup>
const { locale } = useI18n()

const props = defineProps({
  title: {
    type: String,
    default: 'Need help?',
  },
  subtitle: {
    type: String,
    default: 'Find out quickly and easily which product is right for you here.',
  },
  buttonLink: {
    type: String,
    default: null,
  },
  buttonText: {
    type: String,
    default: 'Help me choose',
  },
  strapiData: {
    type: Object,
    default: () => ({}),
  },
  sku: {
    type: String,
    default: '',
  },
})

const computedTitle = computed(() => {
  return props.strapiData?.SelectionAid?.Title
    ? props.strapiData.SelectionAid.Title
    : props.title
})

const computedSubTitle = computed(() => {
  const richtext = props.strapiData?.SelectionAid?.Richtext
  if (!richtext || !richtext.length) return props.subtitle

  return richtext
    .map(block => block.children?.map(child => child.text || '').join('') || '')
    .join('\n')
    .trim()
})

const computedButtonText = computed(() => {
  return props.strapiData?.SelectionAid?.ButtonText
    ? props.strapiData.SelectionAid.ButtonText
    : props.buttonText
})

const computedButtonLink = computed(() => {
  return props.buttonLink || props.strapiData?.SelectionAid?.AidenAdvisorId || ''
})

const processedLink = computed(() => {
  if (!computedButtonLink.value) return null

  const colonIndex = computedButtonLink.value.indexOf(':')

  const [lang, restPath] = [
    colonIndex !== -1 ? computedButtonLink.value.substring(0, colonIndex) : locale.value,
    colonIndex !== -1 ? computedButtonLink.value.substring(colonIndex + 1) : computedButtonLink.value,
  ]

  return new URLSearchParams({
    'data-qonfi-uuid': restPath,
    'data-qonfi-product-id': props.sku,
    'data-qonfi-lang': lang ? lang.toUpperCase() : locale.value.toUpperCase(),
    'data-qonfi-view-type': 'popup',
  }).toString()
})
</script>

<style>
  @import url("~layers/app/components/Product/Qonfi.css");
</style>
